import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  Button,
  TableHead,
  IconButton,
  Switch,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility"; // Import VisibilityIcon for "View"
import NavList from "./NavList";
import { API_ENDPOINTS } from "../../../config/api";
import { useAuth } from "../../../context/AuthContext";

const API_URL = API_ENDPOINTS.PRODUCTS;

const ProductsListContent = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { user } = useAuth();
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, id: null });

  useEffect(() => {
    fetchProducts();
  }, []);

  // console.log(user.permissions); // array of 20 permissions
  // console.log(user.roles);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(API_URL.BASE);
      // console.log("API response:", response.data);
      setProducts(response.data.products || []);
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]);  
    }
  };

  const handleDeleteClick = (id) => {
    setDeleteDialog({ open: true, id });
  };

  const handleDeleteConfirm = async () => {
    const id = deleteDialog.id;
    setDeleteDialog({ open: false, id: null });
    try {
      await axios.delete(API_URL.DELETE(id));
      setProducts((prevProducts) => prevProducts.filter((product) => product.id !== id));
      setSnackbar({
        open: true,
        message: "Product deleted successfully!",
        severity: "success",
      });
    } catch (error) {
      let userMessage = "Failed to delete product.";
      if (
        error.response?.data?.message &&
        error.response.data.message.includes("foreign key constraint fails")
      ) {
        userMessage =
          "Cannot delete this product because it is assigned to other records. Please reassign or remove those records first.";
      }
      setSnackbar({
        open: true,
        message: userMessage,
        severity: "error",
      });
    }
  };

  const handleDeleteCancel = () => {
    setDeleteDialog({ open: false, id: null });
  };

  const handleTogglePublish = async (id, currentStatus) => {
    try {
      await axios.put(API_URL.EDIT(id), { publish: !currentStatus });
      setProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.id === id ? { ...product, publish: !currentStatus } : product
        )
      );
    } catch (error) {
      console.error("Error updating publish status:", error);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const filteredProducts = Array.isArray(products)
    ? products.filter((product) =>
        product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];


  return (
    <Card sx={{ boxShadow: "none", borderRadius: "7px", mb: "25px", padding: "25px" }}>
      <NavList />



      <Box>





        <Box className="search-block"  sx={{ display: "flex", justifyContent: "space-between", mb: "25px" }}>

<div className="search-left">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search product..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ padding: "8px", width: "200px", borderRadius: "5px", border: "1px solid #ccc" }}
          />
          </div>
          
          {user.permissions.includes("add-products") && (
          <Link className="position-button" to="/create-product">
            <Button variant="contained" color="secondary">
              <AddIcon /> Add New Product
            </Button>
          </Link>
          )}
        </Box>




        <TableContainer className="custom-table" component={Paper}>
        
          <Table sx={{ minWidth: 1000 }} aria-label="Products Table">
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Product</TableCell>
              
                <TableCell>Brand</TableCell>
                <TableCell>publish</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{filteredProducts
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((product, index) => (
                <TableRow key={product.id}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell> <img
                        src={product.product_photo}
                        alt={product.product_name}
                        style={{ width: "50px", height: "50px", objectFit: "cover" }}
                      /></TableCell>
                  <TableCell>{product.product_name}</TableCell>
              
                  <TableCell>{product.brand?.name || "N/A"}</TableCell>
                 
                  <TableCell>
                     <Switch
                        checked={!!product.publish}
                        onChange={() => handleTogglePublish(product.id, product.publish)}
                        color="success"
                      />
                  </TableCell>
                  <TableCell align="center">
                  {user.permissions.includes("view-products") && (
                      <Link to={`/products-list/details/${product.id}`}>
                        <IconButton color="info">
                          <VisibilityIcon />
                        </IconButton>
                      </Link>
                    )}
                    {user.permissions.includes("edit-products") && (
                    <Link to={`/edit-product/${product.id}`}>
                      <IconButton color="primary">
                        <EditIcon />
                      </IconButton>
                        </Link>
                    )}
                    {user.permissions.includes("delete-products") && (
                    <IconButton color="error" onClick={() => handleDeleteClick(product.id)}>
                      <DeleteIcon />
                    </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}</TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  count={filteredProducts.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Box>
      <Dialog
        open={deleteDialog.open}
        onClose={handleDeleteCancel}
      >
        <DialogTitle>Delete Product</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this product?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={1000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default ProductsListContent;